module.exports = __webpack_public_path__ + "catalog/items/hex_paso_21/3D_2.1_SIM.obj";